
<div>
  <app-rec-name-search-header [recordCount]="recNameResults.recordCount" [filteredRecordCount]="recNameResults.filteredRecordCount" [isNewTab]="isNewTab" ></app-rec-name-search-header>
</div>
<div>
  <app-rec-name-search-grid [parent]="this" [lastName]="lname" [firstName]="fname" [roleId]="role"></app-rec-name-search-grid>
</div>




